module.exports = __webpack_public_path__ + "static/media/27_BEACHWEAR______CALCINHA_DE_AMARRAR_ESTAMPADA_02.51305592.jpg";